import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "概要", href: "#overview" },
    { label: "4月の時間割", href: "#calendar" },
    { label: "時間割表", href: "#timetable" },
    { label: "コマンド", href: "#commands" },
    { label: "サポート", href: "#support" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-14">
        <a href="#home" className="flex items-center gap-2.5 cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/caeb4770-bff8-4a6c-aacf-b2169351eb6e/f9f885c4-cf1a-4153-aa6b-79a8a47d3db7_unnamed.png?v=32f9e45271c38a3f927699f78a81a4f1"
            alt="時間割くん"
            className="w-7 h-7 rounded-lg object-cover"
          />
          <span className={`font-semibold text-sm tracking-tight transition-colors ${scrolled ? "text-black" : "text-white"}`}>
            時間割くん
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm transition-colors duration-200 cursor-pointer ${
                scrolled ? "text-gray-600 hover:text-black" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* spacer for layout balance */}
        <div className="hidden md:block w-24" />

        <button
          className={`md:hidden text-xl cursor-pointer transition-colors ${scrolled ? "text-black" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 hover:text-black text-sm transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
